/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Andor application API
 * OpenAPI spec version: v1
 */
import {
  HttpClient
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import type {
  Observable
} from 'rxjs';

import type {
  AbortRoomFileUploadResponse,
  BeginRoomFileUploadBody,
  BeginRoomFileUploadResponse,
  CompleteRoomFileUploadResponse,
  DeleteRoomFileBody,
  DeleteRoomFileResponse,
  DownloadRoomFileParams,
  ListRoomFilesParams,
  ListRoomFilesResponse,
  UploadRoomFilePartResponse
} from '../models';

import type {
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';

import {
  ANDOR_BASE_URL
} from '../api.base-url';



interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value
        .filter(
          (item) =>
            item != null &&
            (typeof item === 'string' ||
              typeof item === 'number' ||
              typeof item === 'boolean' ||
              (item instanceof Date && !Number.isNaN(item.getTime()))),
        )
        .map((item) =>
          item instanceof Date ? item.toISOString() : item,
        ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (value === null && requiredNullableKeys.has(key)) {
      // With a paramsSerializer (preserveRequiredNullables) the literal null
      // is passed through for it to consume; without one, emit an empty
      // string so the required key still reaches the wire as `?key=`
      // instead of being silently dropped. See #3712.
      filteredParams[key] = preserveRequiredNullables ? null : '';
    } else if (value instanceof Date && !Number.isNaN(value.getTime())) {
      // useDates produces Date query params; serialize to ISO so they reach
      // the wire instead of being dropped by the primitive check below. See #3856.
      filteredParams[key] = value.toISOString();
    } else if (
      value != null &&
      (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}





@Injectable({ providedIn: 'root' })
export class FilesService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(ANDOR_BASE_URL);
/**
 * Discards the caller's unfinished upload and releases its quota reservation.
 */
 abortRoomFileUpload<TData = AbortRoomFileUploadResponse>(uploadId: string, options?: HttpClientBodyOptions): Observable<TData>;
 abortRoomFileUpload<TData = AbortRoomFileUploadResponse>(uploadId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 abortRoomFileUpload<TData = AbortRoomFileUploadResponse>(uploadId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  abortRoomFileUpload<TData = AbortRoomFileUploadResponse>(
    uploadId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/files/uploads/${encodeURIComponent(String(uploadId))}/abort`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/files/uploads/${encodeURIComponent(String(uploadId))}/abort`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `${this.baseUrl}/v1/files/uploads/${encodeURIComponent(String(uploadId))}/abort`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Registers an upload and reserves its stored size in the instance quota. Requires `shareFiles`. Parts are then sent in order of `partNumber` with exactly `partBytes` bytes each (the last part holds the rest).
 */
 beginRoomFileUpload<TData = BeginRoomFileUploadResponse>(beginRoomFileUploadBody: BeginRoomFileUploadBody, options?: HttpClientBodyOptions): Observable<TData>;
 beginRoomFileUpload<TData = BeginRoomFileUploadResponse>(beginRoomFileUploadBody: BeginRoomFileUploadBody, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 beginRoomFileUpload<TData = BeginRoomFileUploadResponse>(beginRoomFileUploadBody: BeginRoomFileUploadBody, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  beginRoomFileUpload<TData = BeginRoomFileUploadResponse>(
    beginRoomFileUploadBody: BeginRoomFileUploadBody, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/files/uploads`,
      beginRoomFileUploadBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/files/uploads`,
      beginRoomFileUploadBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `${this.baseUrl}/v1/files/uploads`,
      beginRoomFileUploadBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Assembles the caller's upload once every part is stored, publishes the file to the room and announces it to its members.
 */
 completeRoomFileUpload<TData = CompleteRoomFileUploadResponse>(uploadId: string, options?: HttpClientBodyOptions): Observable<TData>;
 completeRoomFileUpload<TData = CompleteRoomFileUploadResponse>(uploadId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 completeRoomFileUpload<TData = CompleteRoomFileUploadResponse>(uploadId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  completeRoomFileUpload<TData = CompleteRoomFileUploadResponse>(
    uploadId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/files/uploads/${encodeURIComponent(String(uploadId))}/complete`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/files/uploads/${encodeURIComponent(String(uploadId))}/complete`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `${this.baseUrl}/v1/files/uploads/${encodeURIComponent(String(uploadId))}/complete`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Deletes any file of a room the caller is in. Requires `shareFiles`.
 */
 deleteRoomFile<TData = DeleteRoomFileResponse>(deleteRoomFileBody: DeleteRoomFileBody, options?: HttpClientBodyOptions): Observable<TData>;
 deleteRoomFile<TData = DeleteRoomFileResponse>(deleteRoomFileBody: DeleteRoomFileBody, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 deleteRoomFile<TData = DeleteRoomFileResponse>(deleteRoomFileBody: DeleteRoomFileBody, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  deleteRoomFile<TData = DeleteRoomFileResponse>(
    deleteRoomFileBody: DeleteRoomFileBody, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/files/delete`,
      deleteRoomFileBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/files/delete`,
      deleteRoomFileBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `${this.baseUrl}/v1/files/delete`,
      deleteRoomFileBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Streams a file's stored bytes (ciphertext for encrypted files) as an attachment.
 */
 downloadRoomFile(fileId: string,
    params: DownloadRoomFileParams, options?: HttpClientBodyOptions): Observable<Blob>;
 downloadRoomFile(fileId: string,
    params: DownloadRoomFileParams, options?: HttpClientEventOptions): Observable<HttpEvent<Blob>>;
 downloadRoomFile(fileId: string,
    params: DownloadRoomFileParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<Blob>>;
  downloadRoomFile(
    fileId: string,
    params: DownloadRoomFileParams, options?: HttpClientObserveOptions): Observable<Blob | HttpEvent<Blob> | AngularHttpResponse<Blob>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get(
      `${this.baseUrl}/v1/files/${encodeURIComponent(String(fileId))}/content`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    ) as Observable<HttpEvent<Blob>>;
    }

    if (options?.observe === 'response') {
      return this.http.get(
      `${this.baseUrl}/v1/files/${encodeURIComponent(String(fileId))}/content`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    ) as Observable<AngularHttpResponse<Blob>>;
    }

    return this.http.get(
      `${this.baseUrl}/v1/files/${encodeURIComponent(String(fileId))}/content`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    ) as Observable<Blob>;
  }
/**
 * Files shared in a room the caller has been admitted to and is present in, plus the instance's storage usage and limits.
 */
 listRoomFiles<TData = ListRoomFilesResponse>(params: ListRoomFilesParams, options?: HttpClientBodyOptions): Observable<TData>;
 listRoomFiles<TData = ListRoomFilesResponse>(params: ListRoomFilesParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 listRoomFiles<TData = ListRoomFilesResponse>(params: ListRoomFilesParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  listRoomFiles<TData = ListRoomFilesResponse>(
    params: ListRoomFilesParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `${this.baseUrl}/v1/files`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `${this.baseUrl}/v1/files`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `${this.baseUrl}/v1/files`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
/**
 * Stores one part of the caller's own upload. The body is the raw part; re-sending a part replaces it.
 */
 uploadRoomFilePart<TData = UploadRoomFilePartResponse>(uploadId: string,
    partNumber: number,
    uploadRoomFilePartBody: Blob, options?: HttpClientBodyOptions): Observable<TData>;
 uploadRoomFilePart<TData = UploadRoomFilePartResponse>(uploadId: string,
    partNumber: number,
    uploadRoomFilePartBody: Blob, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 uploadRoomFilePart<TData = UploadRoomFilePartResponse>(uploadId: string,
    partNumber: number,
    uploadRoomFilePartBody: Blob, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  uploadRoomFilePart<TData = UploadRoomFilePartResponse>(
    uploadId: string,
    partNumber: number,
    uploadRoomFilePartBody: Blob, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/files/uploads/${encodeURIComponent(String(uploadId))}/parts/${encodeURIComponent(String(partNumber))}`,
      uploadRoomFilePartBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/files/uploads/${encodeURIComponent(String(uploadId))}/parts/${encodeURIComponent(String(partNumber))}`,
      uploadRoomFilePartBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `${this.baseUrl}/v1/files/uploads/${encodeURIComponent(String(uploadId))}/parts/${encodeURIComponent(String(partNumber))}`,
      uploadRoomFilePartBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
};
